export default "__VITE_ASSET__DZ6jn86v__"